import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import { useEffect, useRef, useState } from "react";

import TagBadge from "components/TagBadge";
import ClientIconState from "components/ClientIconState";
import { checkFlags } from "utils/checkFlags";
import { ClientFlags } from "dto/IClient";
import { getAvatar } from "utils/getAvatar";
import sanitizeHtml from "sanitize-html";
import { Avatar } from "@mui/material";
import { convertToLetters } from "utils/convertToLetters";
import Chip from "components/Chip";
import {
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClientRolesModal from "components/ClientRolesModal";
import { useOnClickOutside } from "usehooks-ts";
import { useTranslation } from "react-i18next";

const ClientCard: FC<Props> = ({ client, setSelectedEdit, refetch }) => {
  const { t } = useTranslation();
  const { clientId } = useParams();
  const [showRoles, setShowRoles] = useState(false);
  const refWrapper = useRef(null);

  useOnClickOutside(refWrapper, () => {
    setShowRoles(false);
  });

  const hasAvatar = checkFlags(client.Flags, ClientFlags.HasAvatar);

  const [av, setAv] = useState<any>(null);

  const fetchAvatar = async () => {
    setAv(await getAvatar(client!.Id!));
  };

  useEffect(() => {
    if (!hasAvatar) return;
    fetchAvatar();
  }, [hasAvatar]);

  const rippleContainerRef = useRef(null);

  const createRipple = (event: MouseEvent) => {
    const container = rippleContainerRef.current as HTMLElement;
    if (!container) return;

    // Usuń poprzedni ripple, jeśli istnieje
    const oldRipple = container.querySelector(`.${styles.ripple}`);
    if (oldRipple) {
      oldRipple.remove();
    }

    // Utwórz nowy element ripple
    const ripple = document.createElement("span");
    const diameter = Math.max(container.clientWidth, container.clientHeight);
    const radius = diameter / 2;

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${event.clientX - container.offsetLeft - radius}px`;
    ripple.style.top = `${event.clientY - container.offsetTop - radius}px`;
    ripple.classList.add(styles.ripple);

    // Dodaj ripple do kontenera
    container.appendChild(ripple);

    // Usuń ripple po zakończeniu animacji (600ms)
    setTimeout(() => {
      ripple.remove();
    }, 600);
  };

  return (
    <div
      ref={rippleContainerRef}
      onClick={(e) => {
        createRipple(e);
      }}
      className={`${styles.wrapper} ${styles.rippleContainer} ${
        clientId === client?.Id?.toString() && styles.active
      }`}
    >
      <div
        // onClick={() => navigate(`/clients/${filterId}/${client.Id}`)}
        className={`${styles.card}`}
      >
        <div className={styles.ID}>
          <Avatar className={styles.avatar}>
            {convertToLetters(
              client.Name?.replaceAll("<em>", "")?.replaceAll("</em>", "")
            ) ?? ""}
          </Avatar>

          <div className={styles.data}>
            <div
              className={styles.name}
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(client.Name ?? ""),
              }}
            ></div>
            <div className={styles.tag} ref={refWrapper}>
              {client.Tags && client.Tags.length === 1 && (
                <TagBadge tag={client.Tags[0]} />
              )}
              {client.Tags && client.Tags.length > 1 && (
                <Chip
                  onClick={() => setShowRoles(true)}
                  small={true}
                  element={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "3px",
                        lineHeight: "12px",
                      }}
                    >
                      {t("clients.multipleRoles")} <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  }
                />
              )}
            </div>
          </div>
        </div>
        <div className={styles.icons}>
          <ClientIconState client={client} />
        </div>
      </div>

      {showRoles && (
        <ClientRolesModal client={client} refWrapper={refWrapper} />
      )}
    </div>
  );
};

export default ClientCard;
